import React from "react";
import ProtectedRoutes from "./ProtectedRoutes";
import PublicRoutes from "./PublicRoutes";
const isLoggedIn = false;
const Routing = () => {
  return isLoggedIn ? <ProtectedRoutes /> : <PublicRoutes />;
};

export default Routing;
